import { render } from "./TreeviewContent.vue?vue&type=template&id=0aa248c9"
import script from "./TreeviewContent.vue?vue&type=script&lang=js"
export * from "./TreeviewContent.vue?vue&type=script&lang=js"

import "./TreeviewContent.vue?vue&type=style&index=0&id=0aa248c9&lang=scss"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__